import { motion } from 'framer-motion';
import V7_1 from '../../assets/images/home/vector7/vector7-1.svg';
import V7_2 from '../../assets/images/home/vector7/vector7-2.svg';
import V7_3 from '../../assets/images/home/vector7/vector7-3.svg';
import V7_4 from '../../assets/images/home/vector7/vector7-4.svg';
import V7_5 from '../../assets/images/home/vector7/vector7-5.svg';
import V7_6 from '../../assets/images/home/vector7/vector7-6.svg';

const Vector7 = () => {
  return (
    <motion.div className="vector" id="vector7"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.9 }}
    >
      <img src={V7_1} alt="Décoration à gauche" />
      <img src={V7_2} alt="Décoration à gauche" />
      <img src={V7_3} alt="Décoration à gauche" />
      <img src={V7_4} alt="Décoration à gauche" />
      <img src={V7_5} alt="Décoration à gauche" />
      <img src={V7_6} alt="Décoration à gauche" />
    </motion.div>
  );
};

export default Vector7;